<script setup lang="ts">
    import EditButton from '@/components/EditButton.vue';
    import { useI18n } from 'vue-i18n';
    import type { Table, Row } from '@tanstack/vue-table';
    import type { VatSubmission } from '@/types';

    const { t } = useI18n();

    const props = defineProps<{
        table: Table<VatSubmission>;
        row: Row<VatSubmission>;
    }>();

    const editFields = () => {
        props.table.options.meta?.updateData?.(props.row, 'status', 'draft');
    };
</script>

<template>
    <EditButton @click="editFields">
        {{ t('tables.edit') }}
    </EditButton>
</template>
